import React from 'react'
import AssignTrainer from '../admin/AssignTrainer'

const ZoneManagerAssignTrainer = () => {
  return (
   <AssignTrainer/>
  )
}

export default ZoneManagerAssignTrainer